import { render, staticRenderFns } from "./history_data_oto.vue?vue&type=template&id=6ed24364&scoped=true&"
import script from "./history_data_oto.vue?vue&type=script&lang=js&"
export * from "./history_data_oto.vue?vue&type=script&lang=js&"
import style0 from "./history_data_oto.vue?vue&type=style&index=0&id=6ed24364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed24364",
  null
  
)

export default component.exports